import * as ko from "knockout";
import {UPDATING_MESSAGE} from "../../../../../constants/Language";
import {ICompany} from "../../../../../index";
import {global} from "../../../../../appContext";
import {createErrorMessage} from "../../../../../util/misc";
import {nsDate} from "../../nsDate";
import {nsUtils} from "../../nsUtils";
import {StatusManager} from "../../StatusManager";
import {AbstractCard} from "../AbstractCard";
import {MutableNotificationData} from "./MutableNotificationData";
import detailsHtml from './details.html?raw';

export const template = detailsHtml

export class viewModel extends AbstractCard {
    protected override obj: MutableNotificationData;

    protected readonly Keys: (keyof ICompany)[] = [
        'daystosyncstopwarning',
        'sendwarningonstop',
        'syncendreportrecipients',
        'syncendreportsdeactivated',
        'syncendreportsdeactivatedby',
        'syncendreportsdeactivatedbyorgnr',
        'syncerrorreportrecipients',
        'syncstopwarningdeactivated',
        'syncstopwarningdeactivatedby',
        'syncstopwarningdeactivatedbyorgnr',
    ] as const

    constructor(statusManager: StatusManager) {
        super(statusManager)
        this.obj = this.statusManager.mutableNotification
    }

    readonly errorReportDeactivatedText = ko.pureComputed((): string | null => {
        const str = this.statusManager.mutableCompany.props.syncstopwarningdeactivated?.()
        return str ? `sync.statuscards.deactivated|deactivateddate:${nsDate.getDate(str, true)}` : null
    })

    readonly showErrorReportDeactivatedMeta = ko.pureComputed(() => {
        if (this.obj.crudMode() !== 'read') {
            return false
        }
        const p = this.statusManager.mutableCompany.props
        return !!(p.syncstopwarningdeactivated?.() || p.syncstopwarningdeactivatedby?.())
    })

    readonly endReportDeactivatedText = ko.pureComputed((): string | null => {
        const str = this.statusManager.mutableCompany.props.syncendreportsdeactivated?.()
        return str ? `sync.statuscards.deactivated|deactivateddate:${nsDate.getDate(str, true)}` : null
    })

    readonly showEndReportDeactivatedMeta = ko.pureComputed(() => {
        if (this.obj.crudMode() !== 'read') {
            return false
        }
        const p = this.statusManager.mutableCompany.props
        return !!(p.syncendreportsdeactivated?.() || p.syncendreportsdeactivatedby?.())
    })

    protected onSubmitClick() {
        return Promise.resolve()
            .then(() => {
                this.messageData({message: UPDATING_MESSAGE})
                this.statusManager.isSubmitting(true)
                this.updateProps()
            })
            .then(() => this.statusManager.mutableCompany.submit(this.Keys))
            .then(() => this.statusManager.do_getcompany())
            .then(() => this.statusManager.mutableCompany.init())
            .then(() => {
                global.snackbarData({message: 'sync.notification.message.success'})
                this.statusManager.removeCache('getcompany')
            })
            .then(() => this.statusManager.init())
            .catch((reason: string) => {
                this.statusManager.isSubmitting(false)
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private getEmailClass(email: string) {
        return nsUtils.validateEmail(email) ? '' : 'warning'
    }

}
